var React = require('react');

function PauseCircleFill (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"10","key":0}),React.createElement("line",{"x1":"10","x2":"10","y1":"15","y2":"9","key":1}),React.createElement("line",{"x1":"14","x2":"14","y1":"15","y2":"9","key":2})]);
}

PauseCircleFill.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"lucide lucide-pause-circle"};

module.exports = PauseCircleFill;

PauseCircleFill.default = PauseCircleFill;
